/* file description */

import React from 'react';
import RadioSelectMemo from '../component/RadioSelect';
import RadioSelectRender from '../component/RadioSelect/render';
import { TransformNalmalType2TableColumn } from './type';
import { VALUE_TYPES, COLUMN_FROM } from './consts';
import _ from 'lodash';
import { Api as FetchAPI } from '@/utils';

export const transformAseetRadioColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  // FetchAPI,
  isMobile,
}) => {
  // console.groupCollapsed(`${field?.label}#${field?.name} transformAseetRadioColumn`);
  // console.log('入参field', _.cloneDeep(field));
  // console.log('入参targetColumn', _.cloneDeep(targetColumn));

  targetColumn.valueType = VALUE_TYPES.RADIO;

  targetColumn.renderFormItem = () => {
    return <RadioSelectMemo field={field} FetchAPI={FetchAPI} isMobile={isMobile} />;
  };
  targetColumn.render = (dom, entity) => {
    const targerValue = entity?.value;
    const { setViewValue } = entity;
    return <RadioSelectRender field={field} FetchAPI={FetchAPI} targerValue={targerValue} setViewValue={setViewValue} />;
  };

  // console.log('处理后targetColumn', _.cloneDeep(targetColumn));
  // console.groupEnd();

  return targetColumn;
};
